import { StytchHeadlessClient } from "@stytch/vanilla-js/headless";

let client: StytchHeadlessClient;

export const loadStytch = () => {
  if (!client) {
    client = new StytchHeadlessClient(
      import.meta.env.VITE_STYTCH_PUBLIC_TOKEN as string,
    );
  }

  return client;
};
